// extracted by mini-css-extract-plugin
export default {"layout":"SetPassword_layout__2BW2b","card":"SetPassword_card__qAXSy","content":"SetPassword_content__XsKvD","content__title":"SetPassword_content__title__7zOwa"};